module.exports = __webpack_public_path__ + "img/Venezuela.d213ddeb.svg";